var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.loading,
          expression: "loading",
        },
      ],
      staticClass: "corp-wx-account-bind",
    },
    [
      _vm.sources.length
        ? _c(
            "el-tabs",
            {
              model: {
                value: _vm.activeTab,
                callback: function ($$v) {
                  _vm.activeTab = $$v
                },
                expression: "activeTab",
              },
            },
            [
              _c(
                "el-tab-pane",
                { attrs: { label: "第三方账号绑定", name: "normal" } },
                [_vm._t("default")],
                2
              ),
              _c(
                "el-tab-pane",
                { attrs: { label: "侧边栏企微共享绑定", name: "shared" } },
                [
                  _c(
                    "div",
                    { staticClass: "shared-bind-toolbar" },
                    [
                      _vm._v(" 侧边栏企微共享绑定："),
                      _c(
                        "el-button",
                        {
                          staticClass: "m-l-10",
                          attrs: {
                            type: "primary",
                            size: "small",
                            icon: "el-icon-plus",
                          },
                          on: {
                            click: function ($event) {
                              return _vm.openPhoneDialog()
                            },
                          },
                        },
                        [_vm._v("新增")]
                      ),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "shared-bind-list" },
                    [
                      _vm._l(_vm.bindList, function (item) {
                        return _c(
                          "div",
                          { key: item.id, staticClass: "shared-bind-card" },
                          [
                            _c("div", { staticClass: "card-header" }, [
                              _c("span", { staticClass: "tag-wechat" }, [
                                _vm._v("企业微信"),
                              ]),
                              _c("div", { staticClass: "actions" }, [
                                _c(
                                  "span",
                                  {
                                    staticClass: "action-btn bind-btn",
                                    attrs: { role: "button", tabindex: "0" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.openPhoneDialog(item)
                                      },
                                      keydown: [
                                        function ($event) {
                                          if (
                                            !$event.type.indexOf("key") &&
                                            _vm._k(
                                              $event.keyCode,
                                              "enter",
                                              13,
                                              $event.key,
                                              "Enter"
                                            )
                                          )
                                            return null
                                          return _vm.openPhoneDialog(item)
                                        },
                                        function ($event) {
                                          if (
                                            !$event.type.indexOf("key") &&
                                            _vm._k(
                                              $event.keyCode,
                                              "space",
                                              32,
                                              $event.key,
                                              [" ", "Spacebar"]
                                            )
                                          )
                                            return null
                                          $event.preventDefault()
                                          return _vm.openPhoneDialog(item)
                                        },
                                      ],
                                    },
                                  },
                                  [_vm._v("换绑")]
                                ),
                                _c(
                                  "span",
                                  {
                                    staticClass: "action-btn unbind-btn",
                                    attrs: { role: "button", tabindex: "0" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.unbind(item)
                                      },
                                      keydown: [
                                        function ($event) {
                                          if (
                                            !$event.type.indexOf("key") &&
                                            _vm._k(
                                              $event.keyCode,
                                              "enter",
                                              13,
                                              $event.key,
                                              "Enter"
                                            )
                                          )
                                            return null
                                          return _vm.unbind(item)
                                        },
                                        function ($event) {
                                          if (
                                            !$event.type.indexOf("key") &&
                                            _vm._k(
                                              $event.keyCode,
                                              "space",
                                              32,
                                              $event.key,
                                              [" ", "Spacebar"]
                                            )
                                          )
                                            return null
                                          $event.preventDefault()
                                          return _vm.unbind(item)
                                        },
                                      ],
                                    },
                                  },
                                  [_vm._v("解绑")]
                                ),
                              ]),
                            ]),
                            _c("div", { staticClass: "card-content" }, [
                              _c(
                                "div",
                                { staticClass: "user-info" },
                                [
                                  _c(
                                    "el-image",
                                    {
                                      staticClass: "avatar",
                                      attrs: {
                                        src:
                                          item.avatar ||
                                          item.headImageUrl ||
                                          item.bizWechatAvatar ||
                                          "",
                                      },
                                    },
                                    [
                                      _c("template", { slot: "error" }, [
                                        _c("img", {
                                          staticClass: "avatar",
                                          attrs: {
                                            src: require("@/assets/image/imgloadError.png"),
                                          },
                                        }),
                                      ]),
                                    ],
                                    2
                                  ),
                                  _c("div", { staticClass: "name-info" }, [
                                    _c("span", { staticClass: "user-name" }, [
                                      _vm._v(
                                        _vm._s(
                                          item.nickName ||
                                            item.userName ||
                                            item.name ||
                                            item.employeeName ||
                                            item.bizWechatName ||
                                            "未命名"
                                        )
                                      ),
                                    ]),
                                  ]),
                                ],
                                1
                              ),
                              _c("div", { staticClass: "corp-name" }, [
                                _vm._v(
                                  _vm._s(_vm.sourceName(item.sourceTenantId))
                                ),
                              ]),
                            ]),
                          ]
                        )
                      }),
                      !_vm.bindList.length
                        ? _c("div", { staticClass: "shared-bind-empty" }, [
                            _vm._v("暂无共享绑定，请通过手机号绑定企微员工"),
                          ])
                        : _vm._e(),
                    ],
                    2
                  ),
                ]
              ),
            ],
            1
          )
        : _vm._t("default"),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.form.relationId
              ? "侧边栏企微共享换绑"
              : "侧边栏企微共享绑定",
            visible: _vm.phoneDialogVisible,
            width: "420px",
            "append-to-body": "",
            "show-close": !_vm.submitting,
            "close-on-click-modal": false,
            "close-on-press-escape": !_vm.submitting,
          },
          on: {
            "update:visible": function ($event) {
              _vm.phoneDialogVisible = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "phoneForm",
              attrs: {
                model: _vm.form,
                rules: _vm.rules,
                "label-width": "86px",
                size: "small",
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "共享企微", prop: "sourceTenantId" } },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "100%" },
                      attrs: {
                        disabled: !!_vm.form.relationId || _vm.submitting,
                        placeholder: "请选择共享企微",
                      },
                      model: {
                        value: _vm.form.sourceTenantId,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "sourceTenantId", $$v)
                        },
                        expression: "form.sourceTenantId",
                      },
                    },
                    _vm._l(_vm.sources, function (item) {
                      return _c("el-option", {
                        key: item.sourceTenantId,
                        attrs: {
                          label: _vm.sourceName(item.sourceTenantId),
                          value: item.sourceTenantId,
                        },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "手机号", prop: "phone" } },
                [
                  _c("el-input", {
                    attrs: {
                      disabled: _vm.submitting,
                      maxlength: "11",
                      placeholder: "请输入该企微员工的手机号",
                      clearable: "",
                    },
                    model: {
                      value: _vm.form.phone,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.form,
                          "phone",
                          typeof $$v === "string" ? $$v.trim() : $$v
                        )
                      },
                      expression: "form.phone",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  attrs: { size: "small", disabled: _vm.submitting },
                  on: {
                    click: function ($event) {
                      _vm.phoneDialogVisible = false
                    },
                  },
                },
                [_vm._v("取消")]
              ),
              _c(
                "el-button",
                {
                  attrs: {
                    type: "primary",
                    size: "small",
                    loading: _vm.submitting,
                  },
                  on: { click: _vm.submitPhoneBind },
                },
                [_vm._v("确定")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }